import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Status extends Component {
  render() {
    return (
      <div className={'status status--' + this.props.status} status={this.props.status}>
        {this.props.children}
      </div>
    );
  }
}

Status.propTypes = {
  status: PropTypes.string.isRequired,
};

export default Status;



// WEBPACK FOOTER //
// ./src/components/EmailForm/Status.js